import { ReducerAction, State } from '../'
import { Community } from '../interfaces/types'

export enum CommunityActions {
  update = 'update-community',
  remove = 'remove-community',
  updateMultiple = 'updateMultiple-community',
}

export function communityReducer(state: State, action: ReducerAction) {
  switch (action.type) {
    case CommunityActions.update: {
      const { ignoreNotFound, id, data } = action.payload
      if (!id && !data?.id) return state
      const _id = id || data.id
      if (ignoreNotFound && !state.communitiesById[_id]) return state
      return {
        ...state,
        communitiesById: {
          ...state.communitiesById,
          [_id]: {
            ...state.communitiesById[_id],
            ...(typeof data === 'function'
              ? data(state.communitiesById[_id])
              : data),
          },
        },
      }
    }
    case CommunityActions.updateMultiple: {
      const { ignoreNotFound, dataArr = [] } = action.payload
      const { communitiesById } = state

      dataArr.forEach((data: Community) => {
        if (!data.id) return
        if (data.isHidden) return
        if (ignoreNotFound && !communitiesById[data.id]) return state
        communitiesById[data.id] = {
          ...communitiesById[data.id],
          ...data,
        }
      })
      return {
        ...state,
        communitiesById: {
          ...communitiesById,
        },
      }
    }
    case CommunityActions.remove: {
      const { id } = action.payload
      if (!id) return state
      const { communitiesById } = state
      delete communitiesById[id]
      return {
        ...state,
        communitiesById: {
          ...communitiesById,
        },
      }
    }
    default: {
      return state
    }
  }
}
